// Email Settings Component
// Email signature customization

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Mail } from 'lucide-react';

const EmailSettings = ({ emailSignature, onChange }) => {
  return (
    <Card className="border-slate-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Mail className="w-5 h-5 text-teal-500" />
          Email Settings
        </CardTitle>
        <CardDescription>
          Customize follow-up email appearance
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="email_signature">Email Signature</Label>
          <Textarea
            id="email_signature"
            value={emailSignature}
            onChange={(e) => onChange('email_signature', e.target.value)}
            placeholder="Best regards,&#10;Your Firm Name"
            className="mt-1"
            rows={3}
            data-testid="email-signature-input"
          />
          <p className="text-xs text-slate-500 mt-1">Added to all follow-up emails</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default EmailSettings;
